module.exports = __webpack_public_path__ + "img/signature-sample2.6eb5a570.png";